<template>
  <div class="popup">
    <div class="popup__title">
      <div class="title" v-if="getModalData.id">Edit Country</div>
      <div class="title" v-else>Add Country</div>
    </div>
    <form class="form" @submit.prevent="onSubmit">
      <div class="form__bent">
        <label class="form__label">Name</label>
        <div class="form__inlet">
          <input type="text" class="form__field" v-model="form.name"/>
        </div>
      </div>
      <div class="form__bent">
        <label class="form__label">Code</label>
        <div class="form__inlet">
          <input type="text" class="form__field" v-model="form.code"/>
        </div>
      </div>
      <div class="form__btn">
        <button class="btn" type="submit" v-if="getModalData.id">Save</button>
        <button class="btn" type="submit" v-else>Add</button>
      </div>
    </form>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: "ModalCountry",
    computed: {
      ...mapGetters([
        'getModalData',
        'getCountriesOptions'
      ]),
    },
    data() {
      return {
        form: {
          name: '',
          code: '',
        }
      }
    },
    mounted() {
      if (this.getModalData.id) {
        this.form = {
          name: this.getModalData.name,
          code: this.getModalData.code,
        }
      }
    },
    methods: {
      ...mapActions([
        'storeCountry',
        'updateCountry',
      ]),
      onSubmit() {
        if (this.getModalData.id)
          this.updateCountry([this.getModalData.id, this.form])
        else
          this.storeCountry(this.form)
      }
    }
  }
</script>

<style scoped>
  .popup { padding: 50px 100px !important }
</style>